import { Description } from '@radix-ui/react-dialog';
import React from 'react';

import { cn } from '@/services/utils';

const DialogDescription = React.forwardRef<
    React.ElementRef<typeof Description>,
    React.ComponentPropsWithoutRef<typeof Description>
>(({ className, ...props }, ref) => (
    <Description
        ref={ref}
        className={cn('tw-text-t-sm tw-text-muted-foreground', className)}
        {...props}
    />
));

DialogDescription.displayName = Description.displayName;

export { DialogDescription };
